import { render } from "./sd-number.vue?vue&type=template&id=5495c139&scoped=true"
import script from "./sd-number.vue?vue&type=script&lang=js"
export * from "./sd-number.vue?vue&type=script&lang=js"

import "./sd-number.vue?vue&type=style&index=0&id=5495c139&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5495c139"]])

export default __exports__